import Swal from "sweetalert2";
import projectUtils from "../../../../../utils/project-utils.js";
import userService from "../../../../../services/web/user-service.js";

const BASENAME = import.meta.env.BASE_URL;
export const swalExistsCpf = async (agentsCpfExist) => {

    const agents = agentsCpfExist.map(a => {
        const userUrl = `${BASENAME}user-agents/form/${a.id}`
        return `<a class="underline bold" href="${userUrl}" target="_blank">- ${a.name}</a>`
    }).join("<br/>")

    const initMessage = agentsCpfExist.length > 1 ? "Existem cadastros" : "Existe um cadastro"

    return await Swal.fire({
        title: "Atenção",
        icon: "warning",
        html: `${initMessage} com este CPF: <br /> <span>${agents}</span> <br /><br /> Para confirmar, digite <b>prosseguir</b> abaixo:`,
        input: "text",
        confirmButtonText: "Confirmar",
        confirmButtonColor: "#063A6C",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        reverseButtons: true,
        preConfirm(inputValue) {
            if (inputValue.trim() !== "prosseguir") {
                Swal.showValidationMessage("Digite corretamente a palavra-chave");
            }
        },
    })
}

export const validateExistsCpf = async (cpf, currentId) => {
    if (!cpf) return true;

    try {
        const { data } = await userService.getByCpf(cpf);

        if (data) {
            const usersNotCurrent = data.filter(i => i.id.toString() !== currentId)
            if (usersNotCurrent.length > 0) {
                const { isConfirmed } = await swalExistsCpf(usersNotCurrent);
                return isConfirmed;
            }
        }

        return true;
    } catch (e) {
        console.error(e);
        projectUtils.swalErrorMessage("", "Não foi possível validar CPF.", "Ok");
        return false;
    }
}